export default ({ next, store }) => {
  if (!store.getters.isManagerAndBigger && !store.getters.isAlexey) {
    return next({ name: 'time-log-weekly' })
  }

  return next()
}
